import BasicApplication from './basic';
import CfaAddressValidate from './cfaAddressValidate';
import DependentsApplication from './dependents';
import OnboardingI9Application from '../shared/onboardingI9';
import eSignaturesApplication from '../../lib/eSignaturesApplication';
import ScrollToInputError from './scrollToInputError';
import SelectAllSpecificCheckboxes from '../admin_v2/select_all_specific_checkboxes';
import AjaxError from '../shared/AjaxError';
import AchInfoApplication from '../shared/ach_info';

import initApps from '../../lib/initApps';
import Tabs from '../../lib/tabs';
import radioSwitcher from '../../lib/radioSwitcher';
import Mask from '../../lib/mask';
import HoneybadgerLogger from '../../lib/honeybadger';

import 'controllers/index';

import 'regenerator-runtime/runtime';
import 'core-js';

const allApps = [
  Mask,
  Tabs,
  radioSwitcher,
  OnboardingI9Application,
  DependentsApplication,
  eSignaturesApplication,
  HoneybadgerLogger,
  BasicApplication,
  SelectAllSpecificCheckboxes,
  ScrollToInputError,
  CfaAddressValidate,
  AjaxError,
  AchInfoApplication
];

$(document).on('turbo:load', () => {
  initApps(allApps);
});

$(function () {
  const hasScrollToTop = document.getElementsByClassName('scroll-to-top');
  const hasFadingAlert = document.getElementsByClassName('fading-alert');

  if (hasScrollToTop.length > 0) {
    $('html, body').animate({
      scrollTop: ($('.scroll-to-top').first().offset().top)
    }, 500);
  }

  if (hasFadingAlert.length > 0) {
    $('.fading-alert').delay(5000).fadeOut();
  }
});
